import React, { useEffect } from 'react';
import { Link, Route, Switch, withRouter } from 'react-router-dom';
import 'whatwg-fetch';
import MyNavMenuDynamic from './navMenuDynamic';
import useVersioning from '../../../hooks/useVersioning';

const MyNavMenu = ({ location }) => {
  const { needToRefresh, refreshCacheAndReload } = useVersioning();

  // On route changed
  useEffect(() => {
    if (needToRefresh.current) {
      refreshCacheAndReload();
    }
  }, [location, needToRefresh, refreshCacheAndReload]);

  return (
    <div id='divNavMenu'>
      <Switch>
        <Route
          path={'/dashboard/contact/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Contact'} route={'/dashboard/contact/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/contact/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Contact</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/contact/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/customer/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Client'} route={'/dashboard/customer/'} />
              <MyNavMenuDynamic {...props} label={'Site'} route={'/dashboard/customer/site/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
              <MyNavMenuDynamic {...props} label={'Technique'} route={'/dashboard/customer/technical/'} />
            </div>
          )}
        />
        <Route
          path={'/dashboard/customer/site/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Client'} route={'/dashboard/customer/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Site</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/customer/wall/'} />
              <MyNavMenuDynamic {...props} label={'Technique'} route={'/dashboard/customer/technical/'} />
            </div>
          )}
        />
        <Route
          path={'/dashboard/customer/technical/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Client'} route={'/dashboard/customer/'} />
              <MyNavMenuDynamic {...props} label={'Site'} route={'/dashboard/customer/site/'} />
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/customer/wall/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Technique</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/customer/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Client</h6>
              <MyNavMenuDynamic {...props} label={'Site'} route={'/dashboard/customer/site/'} />
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/customer/wall/'} />
              <MyNavMenuDynamic {...props} label={'Technique'} route={'/dashboard/customer/technical/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/deal/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Affaire'} route={'/dashboard/deal/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/deal/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Affaire</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/deal/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/ticket/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Ticket'} route={'/dashboard/ticket/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/ticket/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Ticket</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/ticket/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/task/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Tâche'} route={'/dashboard/task/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/task/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Tâche</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/task/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/appointment/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Rdv'} route={'/dashboard/appointment/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/appointment/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Rdv</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/appointment/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/reminder/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Rappel'} route={'/dashboard/reminder/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/reminder/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Rappel</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/reminder/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/note/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Note'} route={'/dashboard/note/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/note/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Note</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/note/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/productHardware/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Produit'} route={'/dashboard/productHardware/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/productHardware/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Produit</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/productHardware/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/productVirtual/wall/:id?'}
          render={(props) => (
            <div>
              <MyNavMenuDynamic {...props} label={'Produit'} route={'/dashboard/productVirtual/'} />
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Mur</h6>
            </div>
          )}
        />
        <Route
          path={'/dashboard/productVirtual/:id?'}
          render={(props) => (
            <div>
              <h6 className={'navMenuTitle ' + 'menuSelected '}>Produit</h6>
              <MyNavMenuDynamic {...props} label={'Mur'} route={'/dashboard/productVirtual/wall/'} />
            </div>
          )}
        />

        <Route
          path={'/dashboard/rankings/support/tickets'}
          render={() => (
            <div className='text-center'>
              <div>
                <Link to={'/dashboard/rankings/commercial/telecom'}>
                  <h6 className={'navMenuTitle '}>Commercial</h6>
                </Link>
                <h6 className={'navMenuTitle ' + 'menuSelected '}>Support</h6>
              </div>

              <div className='mt-3'>
                <div className={'navMenuTitle ' + 'menuSelected '}>Traitement des Tickets</div>
                <Link to={'/dashboard/rankings/support/customer-ratings'}>
                  <div className={'navMenuTitle '}>Satisfactions clients</div>
                </Link>
              </div>
            </div>
          )}
        />

        <Route
          path={'/dashboard/rankings/support/customer-ratings'}
          render={() => (
            <div className='text-center'>
              <div>
                <Link to={'/dashboard/rankings/commercial/telecom'}>
                  <h6 className={'navMenuTitle '}>Commercial</h6>
                </Link>
                <h6 className={'navMenuTitle ' + 'menuSelected '}>Support</h6>
              </div>

              <div className='mt-3'>
                <Link to={'/dashboard/rankings/support/tickets'}>
                  <div className={'navMenuTitle '}>Traitement des Tickets</div>
                </Link>
                <div className={'navMenuTitle ' + 'menuSelected '}>Satisfactions clients</div>
              </div>
            </div>
          )}
        />

        <Route
          path={'/dashboard/rankings/commercial/telecom/'}
          render={() => (
            <div className='text-center'>
              <div>
                <h6 className={'navMenuTitle ' + 'menuSelected '}>Commercial</h6>
                <Link to={'/dashboard/rankings/support/tickets'}>
                  <h6 className={'navMenuTitle '}>Support</h6>
                </Link>
              </div>

              <div className='mt-3'>
                <div className={'navMenuTitle ' + 'menuSelected '}>Telecom</div>
                <Link to={'/dashboard/rankings/commercial/informatique'}>
                  <div className={'navMenuTitle '}>Informatique</div>
                </Link>
                <Link to={'/dashboard/rankings/commercial/customer-ratings'}>
                  <div className={'navMenuTitle '}>Satisfactions clients</div>
                </Link>
              </div>
            </div>
          )}
        />

        <Route
          path={'/dashboard/rankings/commercial/informatique/'}
          render={() => (
            <div className='text-center'>
              <div>
                <h6 className={'navMenuTitle ' + 'menuSelected '}>Commercial</h6>
                <Link to={'/dashboard/rankings/support/tickets'}>
                  <h6 className={'navMenuTitle '}>Support</h6>
                </Link>
              </div>

              <div className='mt-3'>
                <Link to={'/dashboard/rankings/commercial/telecom'}>
                  <div className={'navMenuTitle '}>Telecom</div>
                </Link>
                <div className={'navMenuTitle ' + 'menuSelected '}>Informatique</div>
                <Link to={'/dashboard/rankings/commercial/customer-ratings'}>
                  <div className={'navMenuTitle '}>Satisfactions clients</div>
                </Link>
              </div>
            </div>
          )}
        />

        <Route
          path={'/dashboard/rankings/commercial/customer-ratings'}
          render={() => (
            <div className='text-center'>
              <div>
                <h6 className={'navMenuTitle ' + 'menuSelected '}>Commercial</h6>
                <Link to={'/dashboard/rankings/support/tickets'}>
                  <h6 className={'navMenuTitle '}>Support</h6>
                </Link>
              </div>

              <div className='mt-3'>
                <Link to={'/dashboard/rankings/commercial/telecom'}>
                  <div className={'navMenuTitle '}>Telecom</div>
                </Link>
                <Link to={'/dashboard/rankings/commercial/informatique'}>
                  <div className={'navMenuTitle '}>Informatique</div>
                </Link>
                <div className={'navMenuTitle ' + 'menuSelected '}>Satisfactions clients</div>
              </div>
            </div>
          )}
        />
      </Switch>
    </div>
  );
};

export default withRouter(MyNavMenu);
